// extracted by mini-css-extract-plugin
module.exports = {"back":"AddPayment_back__13282"};